<script setup lang="ts">
import { ref, reactive, onMounted } from 'vue'
import { CurrencyDollarIcon, UserGroupIcon, CreditCardIcon, PhoneIcon, DocumentIcon } from '@heroicons/vue/24/solid'
import { useAuthStore } from '@base/stores/auth'
import { getFeatureFlag } from '~/services/feature-flag-service'
import { getWithExpiry, setWithExpiry } from '~/services/cacheService'
import { getAppEnvironment } from '~/environments'

const { account, abberviatedUsername } = useAuthStore()
const environment = getAppEnvironment()

const navigation = reactive([
  {
    title: 'Trakr',
    icon: CurrencyDollarIcon,
    to: environment.trakrForSalesUrl,
    target: '_blank'
  },
  {
    title: 'Pet Parent & Policy Holder Search',
    icon: UserGroupIcon,
    to: '/search'
  }
])

const featureFlagKey = 'POL-1061'
const featureFlagValue = ref<boolean | null>(null)

const addPhoneCallSearch = () => {
  navigation.push({
    title: 'Phone Call Search',
    icon: PhoneIcon,
    to: '/phone'
  })
}

const checkFeatureFlagWithCache = async () => {
  const cachedValue = getWithExpiry(featureFlagKey)
  if (cachedValue !== null) {
    return cachedValue
  }
  const value = await getFeatureFlag(featureFlagKey)
  setWithExpiry(featureFlagKey, value)
  return value
}

onMounted(async () => {
  featureFlagValue.value = await checkFeatureFlagWithCache()
  if (featureFlagValue.value) {
    addPhoneCallSearch()
  }
})
</script>

<template>
  <div class="flex flex-col bg-dark h-full w-[64px] py-4 space-y-5 shadow-lg">
    <div class="mx-auto">
      <router-link
        to="/"
        class="flex p-1 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary -m-1"
      >
        <img
          src="/trakr-logos.svg"
          class="size-9 min-w-9 hover:scale-105"
        />
      </router-link>
    </div>
    <div class="h-full flex flex-col space-y-1">
      <nuxt-link
        v-for="(item, index) in navigation"
        :key="index"
        v-tippy="{ content: item.title, placement: 'right' }"
        :to="item.to"
        :target="item.target"
        class="nav-link flex items-center justify-center p-2 rounded mx-auto text-white hover:bg-white hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-inset"
      >
        <UIIcon
          :icon="item.icon"
          size="xl"
        />
      </nuxt-link>
      
      
    </div>
    <div>
      <client-only>
        <div
          v-tippy="{ content: `Logged in as: <strong>${account.name}</strong>`, placement: 'right' }"
          class="bg-[#b4edf4] rounded-full size-9 mx-auto flex items-center justify-center"
        >
          {{ abberviatedUsername }}
        </div>
      </client-only>
    </div>
  </div>
</template>

<style lang="scss">
.nav-link {
  &.router-link-active {
    @apply bg-white text-primary focus-visible:ring-2 focus-visible:ring-inset;
  }
}
</style>
